import React, { useState, useEffect } from "react";
import {  useLocation } from "react-router-dom";
import "./ProductDiscription.css";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";

import Footer from "../../components/Footer/Footer";
import Modal from "../../components/Modal/Modal";

import { CircularProgress } from "@mui/material";

function ProductDiscription() {
  const [quantity, setQuantity] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const price = location?.state?.price || "";
  const numericPrice = parseFloat(price.split(" ")[1]);
  // const { data } = location.state;

  useEffect(() => {
    const storedQuantity = localStorage.getItem("quantity");
    if (storedQuantity) {
      setQuantity(parseInt(storedQuantity));
    }
  }, []);

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const ModalhandleAddToCart = () => {
    // Show the modal when the "Add to cart" button is clicked
    setShowModal(true);
  };
  const handleAddToCart = () => {
    // Show loader
    setIsLoading(true);

    // Simulate an asynchronous action (e.g., API call) - replace this with your actual logic
    setTimeout(() => {
      // Hide loader after the action is complete
      setIsLoading(false);

      // Open the link in the same tab
      window.location.href = "https://buy.stripe.com/test_4gw7t50h875obbq6oo";
    }, 2000); // Simulating a 2-second delay (adjust as needed)
  };

  useEffect(() => {
    localStorage.setItem("quantity", quantity);
    localStorage.setItem("name",location?.state?.name)
    localStorage.setItem("price",location?.state?.price)
  }, [quantity,location?.state?.name,location?.state?.price]);
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <div>
      <div>
        <Header />
        <NavBar />
      </div>
      <div className="Product">
        <div className="img-bordered">
          <img
            className="rounded float-left"
            src={location?.state?.imageSrc}
            alt="medicine"
          />
        </div>
        <div className="Product-disc">
          <h2>{location?.state?.name}</h2>
          <p style={{ fontSize: "15px" }}>
            Brand: <a style={{ color: "#2a579b" }}>Zam Zam Pharma</a>
          </p>
          <p
            style={{
              background: "#eef0f3",
              textAlign: "center",
              padding: "10px",
              width: "120px",
            }}
          >
            {location?.state?.description}
          </p>
          <p>-Anti-dandruff.</p>
          <p>-Anti-fungal shampoo.</p>
          <p>-Ideal to prevent hair fall.</p>
          <p>-Makes hair smooth and silky.</p>
          <p>-Formulated with Biotin, ZPT, and Aloe Vera.</p>
        </div>
        <div className="Product-packs">
          <button
            style={{
              background: "#edf7f6",
              color: "#2a579b",
              width: "230px",
              height: "40px",
              border: "none",
              textAlign: "center",
              borderRadius: "10px",
            }}
          >
            PACK(S)
          </button>

          <p>{location?.state?.price}-each</p>
          <p> {location?.state?.packSize}</p>
          <p style={{ fontSize: "16px", color: "#000" }}>
            Rs. {numericPrice * quantity}
          </p>
          <div className="quantity-controls" style={{marginLeft:'-50%'}}>
            <button onClick={handleDecrement} >-</button>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              min={1}
              style={{ width: "10%",marginTop:'-1px',height:'2.1vh' }}
            />
            <button onClick={handleIncrement} >+</button>
            
          </div>
          <div style={{ position: "relative", width: "100%",  }}>
            {isLoading && (
              <div
                style={{
                  position: "fixed",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // Black overlay with 50% opacity
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: "9999", // Higher z-index to appear above other elements
                }}
              >
                <CircularProgress color="primary" />
              </div>
            )}

            <button
              style={{
                background: "#2a579b",
                color: "#fff",
                width: "230px",
                height: "40px",
                border: "none",
                textAlign: "center",
                borderRadius: "10px",
                marginTop: "10%",
                cursor: "pointer",
              }}
              onClick={ModalhandleAddToCart}
              disabled={isLoading} // Disable the button when loading
            >
              {!isLoading ? "Add to cart" : ""}
            </button>
 
          </div>
        </div>
        {showModal && (
          <Modal
            closeModal={closeModal}
            productInfo={{
              name: location?.state?.name,
              image: location?.state?.imageSrc,
              price: location?.state?.price,
            }}
          
          />
        )}
      </div>
      
      <div className="Description">
        <h1>Description</h1>
        <p>
          This shampoo is formulated with Biotin (Vitamin H), ZPT and Aloe Vera
          to prevent hair fall. If you have dry scalp or a fungus-filled scalp
          then use this shampoo right now. This shampoo makes hair smooth, silky
          and lustrous that people turn and look wherever you go.
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default ProductDiscription;
